import type { ComponentPropsWithoutRef } from "react"
import { forwardRef } from "react"
import { motion } from "motion/react"

import { cn } from "@productlane/lib/src/browser"
import { Button, ProductlaneIcon } from "@productlane/ui"

import type { SlideBaseProps } from "./slide-wrapper"
import { useShortcut } from "@/lib"
import { analytics } from "@/lib/analytics"
import { useSession } from "@/lib/session"

export const WelcomeSlide = forwardRef<
	HTMLDivElement,
	ComponentPropsWithoutRef<"div"> & SlideBaseProps
>(({ nextSlide, className, ...props }, ref) => {
	const { session } = useSession()

	const next = () => {
		analytics.track("start-onboarding", {
			userId: session?.userId,
			workspaceId: session?.workspaceId,
		})
		nextSlide()
	}
	useShortcut("enter", () => {
		next()
	})
	return (
		<div
			ref={ref}
			className={cn("flex flex-col items-center pt-1.5", className)}
			{...props}
		>
			<motion.div
				layoutId="pl-icon"
				className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#191A1C] ring-1 ring-white/10"
			>
				<ProductlaneIcon fill="white" className="h-10" />
			</motion.div>

			<motion.div
				className="mb-3 mt-2 text-center text-4xl font-bold"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 0.2 }}
			>
				Welcome to Productlane
			</motion.div>
			<motion.div
				className="mb-10 text-center text-secondary"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 0.3 }}
			>
				Set up your customer support system around Linear.
			</motion.div>
			<motion.div
				className="w-full max-w-xxs"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 0.4 }}
			>
				<Button
					size="xl"
					className="w-full"
					onClick={() => {
						next()
					}}
				>
					Get Started
				</Button>
			</motion.div>
		</div>
	)
})
